// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".bignumber[data-v-e339a4e6]{position:relative;padding:6px}@media (min-width:700px){.cmc_normal.bignumber[data-v-e339a4e6]{padding:.7em .7em}}@media (min-width:900px){.cmc_normal.bignumber[data-v-e339a4e6]{padding:1.1em 1.1em;margin:1em}}", ""]);
// Exports
module.exports = exports;
